import { matchPath } from 'react-router'
import { UserRole } from '@common/interfaces/user'
import { select, takeEvery } from 'redux-saga/effects'
import { ROUTES } from '../../constants/routes'
import { putPromise } from '../../helpers/redux'
import { show as showClient } from '../clientInfo/actions'
import { loadClientInfo } from '../profile/actions'
import { role } from '../profile/selectors'
import {
  CREATE_FEE_SUCCESS,
  DELETE_FEE_SUCCESS,
  PERMANENT_DELETE_FEE_SUCCESS,
  RESTORE_FEE_SUCCESS,
} from './actions'

export function* updateFeeSuccess() {
  yield takeEvery(
    [CREATE_FEE_SUCCESS, DELETE_FEE_SUCCESS, RESTORE_FEE_SUCCESS, PERMANENT_DELETE_FEE_SUCCESS],
    function* () {
      const path = window.location.pathname
      const userRole = (yield select(role)) as UserRole

      if (
        [UserRole.PORTFOLIO_USER, UserRole.PORTFOLIO_ADMIN, UserRole.ADMIN].includes(userRole) &&
        matchPath({ path: ROUTES.CLIENT_PAGE }, path)
      ) {
        const match = matchPath({ path: ROUTES.CLIENT_PAGE }, path)
        yield putPromise(showClient(match.params.id))
      } else if (userRole === UserRole.CLIENT_USER && matchPath({ path: ROUTES.HOMEPAGE }, path)) {
        yield putPromise(loadClientInfo())
      }
    },
  )
}
